import styled from "styled-components";
export const OrderHistoryWrap = styled.div`
  .textWrap {
    display: flex;
    align-items: center;
    gap: 10px;
    .image-wrapper {
      max-width: 30px;
      height: 30px;
      min-width: 30px;
      background-color: #f0f0f0;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      color: #666;
      font-size: 12px;
      img {
        border-radius: 50%;
        width: 100%;
        height: 30px;
      }
    }
    p {
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }
  }
  .payment-textWrap {
    display: flex;
    gap: 10px;
    .image-wrapper {
      width: 30px;
      height: 20px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .Order-textWrap {
    .delivery {
      color: #e00000;
    }
    .pickup {
      color: var(--black);
    }
  }
  .action-btns {
    .pending,
    .delivered,
    .canceled,
    .ready_for_pickup,
    .preparing,
    .out_for_delivery,
    .accepted,
    .completed {
      width: 99px;
      padding: 10px;
      border-radius: 25px;
    }
    .pending {
      background-color: #feecdf;
    }
    .preparing {
      background-color:rgb(223, 248, 254);
    }
    .accepted {
      background-color:rgb(254, 223, 248);
    }
    .out_for_delivery {
      background-color:rgb(231, 223, 254);
    }
    .ready_for_pickup {
      background-color:rgb(242, 254, 223);
    }
    .delivered {
      background-color: #d9ffe6;
    }
    .canceled {
      background-color: #ff2d2d26;
    }
    .completed {
      background-color: #25a3da26;
    }
  }
`;
export const HeaderWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 20px;
  @media (min-width: 992px) {
    flex-direction: row;
    align-items: center;
    margin-bottom: 30px;
  }
  .left-wrap {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 16px;
      line-height: 20px;
      font-weight: 300;
      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 22px;
      }
    }
  }
  .rightwrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    gap: 20px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: black;
    @media (min-width: 768px) {
      flex-direction: row;
    }
    .date-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 6px;
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      color: black;
      @media (min-width: 768px) {
        gap: 20px;
      }
      .date {
        width: 100%;
        max-width: 140px;
        input {
          padding: 0 10px;
        }
      }
      .custom-date-picker {
        display: flex;
        align-items: center;
        gap: 10px;
        
        input[type="date"] {
          padding: 8px 12px;
          border: 1px solid ${({theme}) => theme?.light?.primary || '#ddd'};
          border-radius: 24px;
          font-size: 14px;
          background-color: var(--white);
          color: #333;
          cursor: pointer;
          transition: border-color 0.2s;
          
          &:hover {
            border-color: ${({theme}) => theme?.light?.primary || '#999'};
          }
          
          &:focus {
            outline: none;
            border-color: ${({theme}) => theme?.light?.primary || '#666'};
            box-shadow: 0 0 0 2px ${({theme}) => theme?.light?.primary}20;
          }
        }
        
        span {
          color: #666;
          font-size: 14px;
          white-space: nowrap;
        }
      }
    }
    .right-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 6px;
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      color: black;
      @media (min-width: 768px) {
        gap: 20px;
      }
      span {
        display: block;
        white-space: nowrap;
      }
      button {
        background-color: ${({ theme }) => theme?.light?.primary50};
        color: var(--black);
      }
    }
  }
  .drop-down {
    cursor: pointer;
    .react-select__control {
      background-color: var(--white);
      border: 1px solid ${({theme}) => theme?.light?.primary};
      height: 40px;
      width: 100px;
      font-size: 14px;
      line-height: 18px;
      cursor: pointer;
    }
    .react-select__placeholder,
    .react-select__single-value,
    svg {
      color: ${({theme}) => theme?.light?.primary};
    }
  }
`;
